import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 w-full flex flex-wrap justify-around" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1)
const _hoisted_3 = { class: "w-full flex flex-wrap justify-between mt-2" }
const _hoisted_4 = { class: "relative z-0 inline-flex shadow-sm rounded-md w-full lg:w-2/3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M6 18L18 6M6 6l12 12"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Taasta filtrid ")
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CabinetsDropdown = _resolveComponent("CabinetsDropdown")!
  const _component_WorkersDropdown = _resolveComponent("WorkersDropdown")!
  const _component_LicenceNosDropdown = _resolveComponent("LicenceNosDropdown")!
  const _component_XRayImagesDropdown = _resolveComponent("XRayImagesDropdown")!
  const _component_MDatePicker = _resolveComponent("MDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CabinetsDropdown, {
      class: "w-full mb-3 lg:w-1/2 lg:pr-1 xl:w-1/3",
      "clinic-u-i-d": _ctx.activeClinicUID,
      "reset-selected-toggle": _ctx.resetToggle,
      "show-selected": true,
      "licence-no": _ctx.licenceNo,
      "show-select-all": "",
      onOnCabinet: _ctx.onCabinet
    }, null, 8, ["clinic-u-i-d", "reset-selected-toggle", "licence-no", "onOnCabinet"]),
    _createVNode(_component_WorkersDropdown, {
      class: "w-full mb-3 lg:w-1/2 lg:pl-1 xl:w-1/3 xl:pr-1",
      "clinic-u-i-d": _ctx.activeClinicUID,
      "show-selected": true,
      onOnWorker: _ctx.onWorker,
      "show-select-all": "",
      "reset-selected-toggle": _ctx.resetToggle
    }, null, 8, ["clinic-u-i-d", "onOnWorker", "reset-selected-toggle"]),
    _createVNode(_component_LicenceNosDropdown, {
      class: "w-full mb-3 lg:w-1/2 lg:pr-1 xl:w-1/3 xl:pr-0",
      "show-select-all": "",
      onOnLicenceNo: _ctx.onLicenceNo,
      "clinic-u-i-d": _ctx.activeClinicUID,
      "reset-selected-toggle": _ctx.resetToggle,
      "cabinet-u-i-d": _ctx.cabinetUID
    }, null, 8, ["onOnLicenceNo", "clinic-u-i-d", "reset-selected-toggle", "cabinet-u-i-d"]),
    _createVNode(_component_XRayImagesDropdown, {
      class: "w-full mb-3 lg:w-1/2 lg:pl-1 lg:mb-2 xl:w-1/3 xl:pl-0 xl:pr-1",
      "show-select-all": "",
      "multi-select": "",
      "reset-selected-toggle": _ctx.resetToggle,
      onOnImages: _ctx.onImages
    }, null, 8, ["reset-selected-toggle", "onOnImages"]),
    _createVNode(_component_MDatePicker, {
      label: "",
      class: "w-full mb-3 lg:w-1/2 lg:mb-2 lg:pr-1 xl:w-1/3 xl:pl-1",
      placeholder: "Alguskuupäev",
      onOnDate: _ctx.setDateFrom,
      "reset-selected-toggle": _ctx.resetToggle,
      "initial-date": _ctx.initialDateFrom
    }, null, 8, ["onOnDate", "reset-selected-toggle", "initial-date"]),
    _createVNode(_component_MDatePicker, {
      label: "",
      class: "w-full mb-2 lg:w-1/2 lg:mb-2 lg:pl-1 xl:w-1/3",
      placeholder: "Lõpukuupäev",
      onOnDate: _ctx.setDateTo,
      "reset-selected-toggle": _ctx.resetToggle,
      "initial-date": _ctx.initialDateTo
    }, null, 8, ["onOnDate", "reset-selected-toggle", "initial-date"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDetailView = false)),
          class: _normalizeClass([!_ctx.isDetailView ? 'bg-indigo-500 text-white' : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-300', "w-1/2 relative inline-flex items-center px-4 py-2 rounded-l-md border text-sm font-medium focus:z-10 focus:outline-none transition duration-300 ease-in-out"])
        }, " Kutsekiirituse dooside aruanne ", 2),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDetailView = true)),
          class: _normalizeClass([_ctx.isDetailView ? 'bg-indigo-500 text-white' : 'bg-white text-gray-700 hover:bg-gray-50  border-gray-300', "w-1/2 relative inline-flex items-center px-4 py-2 rounded-r-md border text-sm font-medium focus:z-10 focus:outline-none transition duration-300 ease-in-out"])
        }, " Detailne statistika ", 2)
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearFilters())),
        type: "button",
        class: "text-red-300 hover:text-red-500 focus:outline-none focus:text-red-500 transition ease-in-out duration-150 inline-flex text-md w-full lg:w-1/3 justify-around my-auto",
        "aria-label": "Close"
      }, _hoisted_6)
    ])
  ]))
}